import { HTMLTagRenderer } from "~/util/HTMLTagRenderer"
import "./index.scss"

export interface CheckboxProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "checked" | "onChange"
  > {
  label: string
  value: string
  selectedValues: string[]
  onChange: (selectedValues: string[]) => void
}

export default function Checkbox(props: CheckboxProps): JSX.Element {
  const { label, value, selectedValues, onChange, ...restProps } = props

  const isChecked = selectedValues.includes(value)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange([...selectedValues, value])
    } else {
      onChange(selectedValues.filter((v) => v !== value))
    }
  }
  return (
    <label className="Checkbox">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="Checkbox__input"
        {...restProps}
      />
      <HTMLTagRenderer string={label} />
    </label>
  )
}
